import "./App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Home from "./components/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { ContentProvider } from "./context/ContentContext";

// Wrappers so Admin pages can navigate without prop drilling
const AdminLoginRoute = () => {
  const navigate = useNavigate();
  return <AdminLogin onLoggedIn={() => navigate("/admin")} />;
};

const AdminDashboardRoute = () => {
  const navigate = useNavigate();
  return <AdminDashboard onLogout={() => navigate("/admin/login")} />;
};

function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminDashboardRoute />} />
          <Route path="/admin/login" element={<AdminLoginRoute />} />
        </Routes>
      </BrowserRouter>
    </ContentProvider>
  );
}

export default App;
